import type { AdminServiceBillingPlan, NormalizeAdminServiceBillingFromApiParams } from '../types';
import normalizeAdminServicePriceComponentFromApi from './normalizeAdminServicePriceComponentFromApi';
import throwUnsupportedAdminServiceBilling from './throwUnsupportedAdminServiceBilling';

const normalizeAdminServiceBillingFromApi = ({
    billing,
}: NormalizeAdminServiceBillingFromApiParams): AdminServiceBillingPlan => {
    const billingRecord = billing as { currency?: unknown; components?: unknown };
    if (billingRecord.currency !== 'usd') {
        return throwUnsupportedAdminServiceBilling({
            message: `Unsupported service billing from API: currency ${String(
                billingRecord.currency
            )}`,
        });
    }

    const storedComponents = billingRecord.components;
    if (!Array.isArray(storedComponents)) {
        return throwUnsupportedAdminServiceBilling({
            message: 'Unsupported service billing from API: components must be an array',
        });
    }

    return {
        currency: 'usd',
        components: storedComponents.map(component =>
            normalizeAdminServicePriceComponentFromApi({ component })
        ),
    };
};

export default normalizeAdminServiceBillingFromApi;
